import { startOfDay } from 'date-fns';

/**
 * Group the data by day and count the number of applications
 *
 * @param data - The data to group
 * @returns The grouped data
 */
export function groupDaily({ data }: { data: { dateCreated: string }[] }) {
    // From the data, group by day and count the number of applications, keep the day as timestamp
    const groupedData = data.reduce(
        (acc: Record<string, number>, item: { dateCreated: string }) => {
            const day = startOfDay(new Date(item.dateCreated)).getTime();
            acc[day] = (acc[day] || 0) + 1;
            return acc;
        },
        {}
    );
    return Object.entries(groupedData).map(([timestamp, value]) => ({
        name: timestamp,
        values: { 'Number of Applications': value }
    }));
}
